"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./FlyoutTile.css");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("../../../util/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// TODO:: GR-7482
var FlyoutTile = /*#__PURE__*/function (_React$Component) {
  _inherits(FlyoutTile, _React$Component);

  var _super = _createSuper(FlyoutTile);

  function FlyoutTile() {
    _classCallCheck(this, FlyoutTile);

    return _super.apply(this, arguments);
  }

  _createClass(FlyoutTile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          tileName = _this$props.tileName,
          tileDescription = _this$props.tileDescription,
          additionalClass = _this$props.additionalClass,
          imgAlt = _this$props.imgAlt,
          imgPath = _this$props.imgPath,
          url = _this$props.url;

      var onKeyUp = function onKeyUp(e) {
        if (e.keyCode === _constants.KEYCODES.ENTER) {
          e.preventDefault();
          window.location = url;
        }
      };

      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("flyout-tile", "product-container", "overview-container", additionalClass),
        onClick: function onClick() {
          window.location = url;
        },
        role: "button",
        tabIndex: 0,
        onKeyUp: onKeyUp
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: imgAlt,
        className: "flyout-tile-image",
        src: imgPath
      }), /*#__PURE__*/_react.default.createElement("h2", {
        className: "flyout-tile-header"
      }, tileName), /*#__PURE__*/_react.default.createElement("p", {
        className: "flyout-tile-desc"
      }, tileDescription));
    }
  }]);

  return FlyoutTile;
}(_react.default.Component);

_defineProperty(FlyoutTile, "propTypes", {
  tileName: _propTypes.default.string.isRequired,
  tileDescription: _propTypes.default.string.isRequired,
  imgAlt: _propTypes.default.string.isRequired,
  imgPath: _propTypes.default.string.isRequired,
  url: _propTypes.default.string,
  label: _propTypes.default.string,
  additionalClass: _propTypes.default.string
});

var _default = FlyoutTile;
exports.default = _default;